const sanitiseCookingTime = (cookingTime: number) => {
  const pluralise = (n: number) => (Number(n) === 1 ? '' : 's');

  const hours = Math.floor(cookingTime / 60);
  const minutes = cookingTime % 60;

  if (minutes === 0) {
    return `${hours}hr${pluralise(hours)}`;
  }
  if (hours === 0) {
    return `${minutes}mins`;
  }
  if (hours !== 0 && minutes !== 0) {
    return `${hours}hr${pluralise(hours)} ${minutes}min${pluralise(minutes)}`;
  }
  return '';
};

export const sanitiseCookingTimes = (
  minCookingTime: number,
  maxCookingTime: number,
): string => {
  const minTime = sanitiseCookingTime(minCookingTime);
  const maxTime = sanitiseCookingTime(maxCookingTime);
  if (minTime === maxTime) {
    return minTime;
  }
  return `${minTime}-${maxTime}`;
};
